<template>
  <div class="plan">
    <h2>院校招生计划</h2>
    <el-table :data="tableData" border stripe>
      <el-table-column prop="name" label="院校名称"> </el-table-column>
      <el-table-column prop="localTypeName" label="专业类别"> </el-table-column>
      <el-table-column prop="localBatchName" label="专业批次">
      </el-table-column>
      <el-table-column prop="spname" label="专业名称"> </el-table-column>
      <el-table-column prop="sgName" label="专业组"> </el-table-column>
      <el-table-column prop="num" label="招生人数"> </el-table-column>
      <el-table-column prop="tuition" label="学费"> </el-table-column>
      <el-table-column prop="year" label="年份"> </el-table-column>
      <el-table-column prop="sgInfo" label="选课要求"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import recommend from "../../api/recommend";
export default {
  name: "Plan",
  data() {
    return {
      queryInfo: {
        name: "",
        major: "",
      },
      tableData: [],
    };
  },
  methods: {
    async getPlan() {
      const res = await recommend.plan(this.queryInfo);
      if (res.code !== 20000) return this.$message.error("请求失败！");
      this.tableData = res.data;
    },
  },
  created() {
    this.queryInfo.name = this.$route.query.name;
    this.queryInfo.major = this.$route.query.major;
    this.getPlan();
  },
};
</script>

<style scoped>
div.plan {
  height: 100%;
  overflow: auto;
}

.plan h2 {
  text-align: center;
  font-weight: 400;
  height: 80px;
  background-image: url("../../assets/img/bk3.png");
  background-size: cover;
  line-height: 80px;
  font-size: 30px;
  color: #fff;
  letter-spacing: 10px;
  margin-bottom: 30px;
}
</style>
